import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL_ACCOUNTING;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}
const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}


export const postStatement = (state, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let user_id = localStorage.getItem('XX')
        let token = localStorage.getItem("tokenA");
        const body = {
            statement_date: state.statement_date,
            production_crew: state?.production_crew,
            type: state.type,
            number: state.number,
            account_id: state.account_id,
            project_id: state.project_id
        }
        console.log(body)
        axios.post(`${END_POINT}/api/expense-statements`, body, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_STATEMENT));
                dispatch(loadStatements());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const loadStatements = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/expense-statements`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_STATEMENTS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}


export const loadOneStatement = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/expense-statements/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_ONE_STATEMENT));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const emptyOneStatement = () => {
    return function (dispatch) {
        let emptyy = {}
        dispatch(emptyGeneral(emptyy, types.EMPTY_ONE_STATEMENT))
    }
}

export const getPageListStatement = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/expense-statements/create`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res?.data?.data, types.PAGE_LIST_STATEMENT));
            }
        }).catch((err) => {
            //notifyError(err.response.data.message)
        })
    }
}

export const putStatement = (id, state, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        let user_id = localStorage.getItem('XX')
        console.log('production_crew', state?.production_crew)
        const filteredProductionCrew = state?.production_crew?.filter(crew => crew !== undefined);
        const body = {
            statement_date: state.statement_date,
            production_crew: filteredProductionCrew?.map((crew) => {
                console.log(crew)
                if (crew !== undefined) {
                    if (crew?.value !== undefined)
                        return crew?.value
                    else
                        return crew
                }
            }),
            type: state.type,
            number: state.number,
            account_id: state.account_id,
            project_id: state.project_id
        }
        console.log('edit', body)
        axios.put(`${END_POINT}/api/expense-statements/${id}`, body, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_ACCOUNT));
                dispatch(loadStatements());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}

export const filterStatement = (project_id, user_id, account_id, statement_date, search_value, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (project_id !== '') queryParams.push(`filters[project_id]=${project_id}`);
        if (user_id !== '') queryParams.push(`filters[user_id]=${user_id}`);
        if (account_id !== '') queryParams.push(`filters[account_id]=${account_id}`);
        if (statement_date !== '') queryParams.push(`filters[statement_date]=${statement_date}`);
        if (search_value !== '') queryParams.push(`filters[search_value]=${search_value}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/expense-statements?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
            dispatch(get(res.data.data, types.GET_STATEMENTS));
        }).catch((err) => {
            ;
            setLoad(false);
        });
    };
};


